import { render, staticRenderFns } from "./Workflow.vue?vue&type=template&id=1154cf17&scoped=true&"
import script from "./Workflow.vue?vue&type=script&lang=js&"
export * from "./Workflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1154cf17",
  null
  
)

export default component.exports